import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './service/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'list',
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'order-section',
    loadChildren: () => import('./seller-order-section/seller-order-section.module').then(m => m.SellerOrderSectionPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'main-page-home-buyer',
    loadChildren: () => import('./main-page-home-buyer/main-page-home-buyer.module').then(m => m.MainPageHomeBuyerPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./edit-profile/edit-profile.module').then(m => m.EditProfilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'add-product',
    loadChildren: () => import('./add-product/add-product.module').then(m => m.AddProductPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'upload-product',
    loadChildren: () => import('./upload-product/upload-product.module').then(m => m.UploadProductPageModule),
    canActivate: [AuthGuardService]
  },
   {
    path: 'quick-product',
    loadChildren: () => import('./quick-product/quick-product.module').then(m => m.QuickProductPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'display-user-order',
    loadChildren: () => import('./display-user-order/display-user-order.module').then( m => m.DisplayUserOrderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'display-user-order-product-detail',
    loadChildren: () => import('./display-user-order-product-detail/display-user-order-product-detail.module').then( m => m.DisplayUserOrderProductDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'connection-profile',
    loadChildren: () => import('./my-connection-profile/my-connection-profile.module').then(m => m.MyConnectionProfilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'wishlist-product',
    loadChildren: () => import('./wishlist-product/wishlist-product.module').then(m => m.WishlistProductPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'connection-page',
    loadChildren: () => import('./connection-page/connection-page.module').then(m => m.ConnectionPagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'my-group',
    loadChildren: () => import('./seller-group/my-group/my-group.module').then(m => m.MyGroupPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'create-group',
    loadChildren: () => import('./seller-group/create-group/create-group.module').then(m => m.CreateGroupPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'group-info',
    loadChildren: () => import('./seller-group/group-info/group-info.module').then(m => m.GroupInfoPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-list',
    loadChildren: () => import('./product-list/product-list.module').then( m => m.ProductListPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-list/:id',
    loadChildren: () => import('./product-list/product-list.module').then( m => m.ProductListPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'public-product',
    loadChildren: () => import('./public-product/public-product.module').then( m => m.PublicProductPageModule)
  },
  {
    path: 'select-field',
    loadChildren: () => import('./select-field/select-field.module').then(m => m.SelectFieldPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-detail',
    loadChildren: () => import('./product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-detail/:id',
    loadChildren: () => import('./product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'share-multiple-product-with-users',
    loadChildren: () => import('./share-multiple-product-with-users/share-multiple-product-with-users.module').then(m => m.ShareMultipleProductWithUsersPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'checkout-order',
    loadChildren: () => import('./checkout-order/checkout-order.module').then( m => m.CheckoutOrderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'edit-product',
    loadChildren: () => import('./edit-product/edit-product.module').then( m => m.EditProductPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'request-access',
    loadChildren: () => import('./request-access/request-access.module').then( m => m.RequestAccessPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'album-detail',
    loadChildren: () => import('./album-detail/album-detail.module').then( m => m.AlbumDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    redirectTo: 'home'
  },
  



  // {
  //   path: 'image-slider-model',
  //   loadChildren: () => import('./image-slider-model/image-slider-model.module').then( m => m.ImageSliderModelPageModule)
  // },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
